/**
 * Agent pause and resume (specs/c2-kontratlar.md 2.3, 2.4.5, K12). Only the board
 * reactivates an agent. An agent disabled by config (status_reason 'config') is never
 * resumed from any surface; a growth agent is resumed only from the panel with a hold
 * token (aid "agent:<agentId>").
 */
import { z } from 'zod';
import { configAgentIdSchema, telegramUserIdSchema } from '../ids.js';
import { HOLD_TOKEN_MAX } from './decisions.js';
const reason = z.string().min(1).max(500);
/** POST /api/v1/agents/{agentId}/pause and /resume. */
export const agentControlRequestSchema = z.discriminatedUnion('channel', [
    z.strictObject({
        channel: z.literal('panel'),
        reason: reason.optional(),
        /** Required to resume a growth agent (data_domain 'growth'). */
        holdToken: z.string().min(1).max(HOLD_TOKEN_MAX).optional(),
    }),
    z.strictObject({ channel: z.literal('telegram'), telegramUserId: telegramUserIdSchema, reason: reason.optional() }),
]);
export const agentStatusSchema = z.enum(['active', 'paused', 'disabled', 'trial']);
export const agentControlResponseSchema = z.object({
    agentId: configAgentIdSchema,
    status: agentStatusSchema,
});
//# sourceMappingURL=agents.js.map